export default {
  screenMaintenance: {
    notes:
      'Protocol name shown for screen maintenance activities in the activities list',
    message: 'Screen maintenance',
  },
  screenActivity: {
    tabs: {
      plan: {
        notes: 'Label for the plan tab on the screen activity details page',
        message: 'Plan',
      },
      measure: {
        notes: 'Label for the measure tab on the screen activity details page',
        message: 'Measure',
      },
      performance: {
        notes:
          'Label for the performance tab (perform maintenance) on the screen activity details page',
        message: 'Performance',
      },
      notes: {
        notes:
          'Label for the notes and images tab on the screen activity details page',
        message: 'Notes & Images',
      },
    },
    lockedTabs: {
      measure: {
        notes:
          'Tooltip on the disabled measure tab while every deck of the screen activity is still being planned',
        message: 'Mark the plan as planned to unlock measurement recording',
      },
      performance: {
        notes:
          'Tooltip on the disabled performance tab while every deck of the screen activity is still being planned',
        message: 'Mark the plan as planned to unlock execution recording',
      },
    },
    planTitle: {
      notes:
        'Title for the layout content area when the plan tab is selected on the screen activity details page',
      message: 'Maintenance plan',
    },
    maintenanceTitle: {
      notes:
        'Title for the layout content area when the maintenance tab is selected on the screen activity details page',
      message: 'Maintenance',
    },
    measureTitle: {
      notes:
        'Title for the layout content area when the measure tab is selected on the screen activity details page',
      message: 'Measurement',
    },
    notesTitle: {
      notes:
        'Title for the layout content area when the notes and images tab is selected on the screen activity details page',
      message: 'Notes & Images',
    },
    initialColumn: {
      notes:
        'Title for the left panel layout column on the screen activity details page, showing the current state of the screen',
      message: 'Initial',
    },
    previousMaintenanceColumn: {
      notes:
        'Title for the left panel layout column on the notes tab of the screen activity details page, showing the notes from the previous maintenance of the deck',
      message: 'Previous maintenance',
    },
    plannedColumn: {
      notes:
        'Title for the right panel layout column on the screen activity details page, showing the planned configuration',
      message: 'Planned',
    },
    maintenancePlannedColumn: {
      notes:
        'Title for the left panel layout column on the maintenance tab, showing the planned actions',
      message: 'Planned',
    },
    maintenancePerformedColumn: {
      notes:
        'Title for the right panel layout column on the maintenance tab, showing the execution status of the planned actions',
      message: 'Performed',
    },
    measurePreviousColumn: {
      notes:
        'Title for the left panel layout column on the measure tab, showing the measurements from the previous maintenance',
      message: 'Previous maintenance',
    },
    measurePreviousColumnDated: {
      notes:
        'Title for the left panel layout column on the measure tab when the previous maintenance is known. {{date}} is the date it was performed',
      message: 'Previous maintenance ({{date}})',
    },
    measureProgressColumn: {
      notes:
        'Title for the right panel layout column on the measure tab, showing the measuring progress of this maintenance',
      message: 'Measuring in progress',
    },
    measureFields: {
      workingDepth: {
        notes:
          'Toggle option on the measure tab that shows the remaining working depth as panel cell content',
        message: 'Working depth',
      },
      apertureWidth: {
        notes:
          'Toggle option on the measure tab that shows the current aperture width as panel cell content',
        message: 'Aperture width',
      },
    },
    selectionDetails: {
      header: {
        notes:
          'Header for the selection details pane on the screen activity details page',
        message: 'Selection details',
      },
    },
    newDialog: {
      header: {
        notes: 'Header in the new screen maintenance activity dialog',
        message: 'New screen activity',
      },
      name: {
        notes:
          'Label for the name input field in the new screen activity dialog',
        message: 'Name',
      },
    },
  },
};
